module.exports = "images/5ans.63e5ffe7.png";